import { nextTick } from "vue";
import { useRoute, useRouter } from "#app";
export function useUrlMutations() {
  const route = useRoute();
  const router = useRouter();
  function updateUrlQuery(query = {}) {
    nextTick(function() {
      const existingQuery = route.query;
      router.replace({
        query: {
          ...existingQuery,
          ...query
        }
      }).catch(() => {
      });
    });
  }
  return {
    updateUrlQuery
  };
}
